import { Component, Input} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ENV_CONFIG } from '../../../bin/env.config';

export interface IPhoto {
  raw: boolean,
  name: string,
  photoType: number,
  isProcessing?: boolean
}

@Component({
  selector: 'smr-booking-photo-editor',
  templateUrl: './booking-photo-editor.component.html',
  styleUrls: ['./booking-photo-editor.component.scss'],
})
export class BookingPhotoEditorComponent {

  public BOOKING_PHOTO_FULL_RES_ROOT: string;

  public BOOKING_PHOTO_ROOT: string;

  public THUMBNAIL_PHOTO_ROOT: string;

  @Input() photo: IPhoto;

  constructor (private modalCtrl: ModalController) {
    this.BOOKING_PHOTO_FULL_RES_ROOT = ENV_CONFIG.BOOKING_PHOTO_FULL_RES_ROOT;
    this.THUMBNAIL_PHOTO_ROOT = ENV_CONFIG.THUMBNAIL_PHOTO_ROOT;
    this.BOOKING_PHOTO_ROOT = ENV_CONFIG.BOOKING_PHOTO_ROOT;

  }

  public onDismiss () {
    this.modalCtrl.dismiss();
  }
}
